import { stringify } from './utils';
import { getConfig } from './services/index';

let baseUrl = '/'
export function setBaseUrl(base: string) {
    baseUrl = base;
}

const pendingRequest: Record<string, {
    reject: (reason?: any) => void;
    xhr: XMLHttpRequest;
}> = {};

export function cancelRequest(url: string) {
    if (!pendingRequest[url]) {
        return;
    }
    const { reject, xhr } = pendingRequest[url];
    xhr.abort();
    reject('From Cancel Request');
}

export function request<Response = unknown>(url: string, data: Record<string, any>, method = 'POST') {
    cancelRequest(url);
    // 附加 language 语言参数
    const { language } = getConfig();
    if (language) {
        data.language = language;
    }
    const finalBaseUrl = data.baseUrl || baseUrl;
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(method, finalBaseUrl + url);
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.responseType = 'json';
        xhr.withCredentials = true;
        // 只有异步才能设置timeout
        xhr.onload = () => {
            delete pendingRequest[url];
            let res = xhr.response;
            if (typeof res === 'string') {
                // ie 11 xhr.responseType = 'json'; 这个设置是无效的
                // https://github.com/naugtur/xhr/issues/123
                try {
                    res = JSON.parse(res);
                } catch(e) {
                    reject(e);
                }
            }
            const status = xhr.status;
            if (status < 200 && status >= 300 && status !== 304 || res.result !== 1) {
                reject(res as Response);
            } else {
                resolve(res);
            }
        };

        xhr.ontimeout = xhr.onerror = e => {
            reject(e);
        };
        pendingRequest[url] = {
            reject,
            xhr,
        };
        xhr.send(stringify(data));
    }) as Promise<Response>;
}
